import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';

const SettingsLogic = () => {
    const location = useLocation();
    const [activeTab, setActiveTab] = useState(getActiveTab(location.pathname));

    function getActiveTab(pathname) {
        if (pathname.includes('UpdatePassword')) {
            return 'UpdatePassword';
        }
        else {
            return 'profile'; // Default to 'profile'
        }
    }

    const navigate = useNavigate();

    // Add logic here to handle default navigation to Profile when /Settings is accessed
    useEffect(() => {
        // Redirect to Profile page if accessing /Settings without a nested path
        if (window.location.pathname === "/Settings") {
            navigate("/Settings/Profile");
        }
    }, [navigate]);

    useEffect(() => {
        setActiveTab(getActiveTab(location.pathname));
    }, [location.pathname]);

    const handleTabChange = (tab) => {
        setActiveTab(tab);
    };
    return (
        {activeTab,handleTabChange}
    )
}

export default SettingsLogic